
import { DateTime } from 'luxon';

// eslint-disable-next-line
const urlRegex = /(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

export const Formatters = {

    isNullOrUndef(value) { return (value == null || value == undefined); },

    /*Dates*/

    fromISO(date) {
        var f = DateTime.fromISO(date?.endsWith('Z') || date?.match(/.T.*[+-]/) ? date : date + 'Z');
        return f.isValid ? f : null;
    },

    fullDateTime(date) {
        return Formatters.fromISO(date)?.toLocaleString(DateTime.DATETIME_FULL);
    },

    localDate(date) {
        return Formatters.fromISO(date)?.toLocaleString();
    },

    localDateTime(date) {
        return Formatters.fromISO(date)?.toLocaleString(DateTime.DATETIME_SHORT);
    },

    localDateTimeSeconds(date) {
        //return Formatters.fromISO(date)?.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);
        let d = Formatters.fromISO(date);
        if (d) {
            return d.toLocaleString(DateTime.DATE_SHORT) + ' ' + d.toLocaleString(DateTime.TIME_WITH_SECONDS);
        }
    },

    localTimeSeconds(date) {
        return Formatters.fromISO(date)?.toLocaleString(DateTime.TIME_WITH_SECONDS);
    },

    relativeDateTime(date) {
        return Formatters.fromISO(date)?.toRelative();
    },

    toISODate(date) {
        return DateTime.fromJSDate(date).toUTC().toISO();
    },

    /*Numbers*/

    money(value, digits) {
        var num = Formatters.numSeparator(Number(value ?? 0).toFixed(digits ?? 2));
        return `$${num}`;
    },

    numRelative(value) {
        if (Math.abs(value) > 999999999) {
            return `${Formatters.round(value / 1000000000, 2)}B`.replace('.00','');
        }
        if (Math.abs(value) > 999999) {
            return `${Formatters.round(value / 1000000, 2)}M`.replace('.00', '');
        }
        if (Math.abs(value) > 9999) {
            return `${Formatters.round(value / 1000, 1)}K`.replace('.00', '');
        }
        return value;
    },

    numSeparator(value) {
        return Formatters.isNullOrUndef(value)
            ? value
            :`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    percent(value, digits) {
        return Formatters.isNullOrUndef(value)
            ? value
            : `${Formatters.round(value, digits)}%`;
    },

    round(value, digits) {
        return Formatters.isNullOrUndef(value)
            ? value
            : Number(value).toFixed(digits ?? 2);
    },

    /*Strings*/

    commaSeparated() {
        return Array.from(arguments).filter(a => a).join(', ');
    },

    json(value, indent) {
        if (typeof (value) === 'string') {
            return JSON.stringify(JSON.parse(value), null, indent ?? 2);
        }
        return JSON.stringify(value, null, indent ?? 2);
    },

    obfuscated(value) {
        return '••••••••••';
    },

    onoff(value) {
        return value ? 'ON' : 'OFF'
    },

    parseUrl(value) {
        let match = value?.match(urlRegex);
        if (match?.length) {
            return match[0];
        }
    },

    phoneNumber(value, countryCode) {
        if (!value) return value;
        let str = `${value}`
        if (!countryCode) {
            while (str[0] === '+' || str[0] === '1') {
                str = str.substring(1);
            }
        }
        if (str.length === 7) {
            return str.replace(/\B(?=(\d{3})+(?!\d))/g, '-');
        } else if (str.length === 10 || str.length === 11) {
            const cleaned = str.replace(/\D/g, '');
            const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                const intlCode = (match[1] ? '+1 ' : '');
                return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
            }
        }
        return value;
    },

    stringArrayFormatter(value) {
        return value?.length ? value.join(', ') : '';
    },

    yesno(value) {
        return value ? 'Yes' : 'No'
    },
}
